import React from 'react';
import type {NextPage} from "next";
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import TextArea from "../src/components/textArea/TextArea";
import WaveLayout from '../src/layouts/WaweLayout';
import CookieTable from "../src/components/cookieTable/CookieTable";
import Link from "next/link";
import GeneralBreadcrumb from "../src/components/breadcrumb/GeneralBreadcrumbComp";
import {NavigationURLs} from "../src/functions/NavigationFunctions";

const CerezPolitikasi: NextPage = () => {
    const breadcrumbItems = [
        { label: 'Pembe Panjur', link: NavigationURLs.landing },
        { label: 'Çerez Politikası'}
    ];
    return (
        <React.Fragment>
            <HtmlHead
                pageTitle="Çerez Politikası | Pembe Panjur"
                description="Pembe Panjur çerez politikası ile ilgili detaylara sayfamızdan ulaşabilirsiniz."
            />
            <WaveLayout bodyBackgroundColor={false} backgroundColor={'unset'} loginButtonText={false}
                        hamburgerMenuType={'black'} registerButton={true}>
                <TextArea className={'mobile-plr0'}>
                    <GeneralBreadcrumb items={breadcrumbItems} margin={false} colorProps={false}/>
                    <h1 className={'mobile-h2-style'}>Çerezlerle Kişisel Veri İşlenmesi Hakkında Aydınlatma
                        Metni</h1>
                    <p>
                        https://www.pembepanjur.com/web sitesini ziyaretiniz kapsamında çerezler (cookies), reklam
                        kimlikleri ve web tanımlayıcıları gibi teknolojileri (bu teknolojilerin tamamı <span
                        style={{fontWeight: 'bold'}}>“Çerez” </span>
                        olarak ifade edilecektir) kullanılmaktadır. Çerezlerle kişisel veri işlenmesi hakkındaki
                        işbu aydınlatma metnini <span style={{fontWeight: 'bold'}}>(Çerez Aydınlatması) </span> sizi
                        Panjur Bilişim ve Danışmanlık Hizmetleri
                        Ticaret A.Ş. <span
                        style={{fontWeight: 'bold'}}>(Pembe Panjur, pembepanjur.com) </span> çerez kullanımı
                        hakkında aydınlatmak amacıyla
                        hazırladık.
                    </p>

                    <h2 className={'desktop-mt-0'}>
                        Çerez (Cookie) Nedir
                    </h2>

                    <p>
                        Çerezler, ziyaret ettiğiniz internet siteleri tarafından tarayıcılar aracılığıyla
                        bilgisayarınıza (ya da akıllı telefon veya tablet gibi diğer cihazlarınıza) kaydedilen ve
                        genelde harf ve rakamlardan oluşan çok küçük metin dosyalarıdır. Çerezler kullanıcının ve
                        cihazının tanınmasına, kullanıcının tercihleri ve geçmiş işlemleriyle ilgili bazı bilgilerin
                        depolanmasını sağlar. Çerezler, ziyaret ettiğiniz web sitesini yöneten sunucular tarafından
                        oluşturulurlar. Böylelikle ziyaretçi aynı siteyi ziyaret ettiğinde sunucu bunu anlayabilir.
                        Çerezler, web sitesi sahiplerine aynı ziyaretçinin siteyi yeniden ziyaret ettiğini gösteren
                        kimlik kartlarına benzetilebilir.
                        Çerezler konusunda daha detaylı bilgi için <Link href={'https://www.aboutcookies.com/'}
                                                                         style={{color: '#000'}} target={'_blank'}
                                                                         rel={'noopener noreferrer'}>www.aboutcookies.com</Link> ve <Link
                        href={'https://www.allaboutcookies.org'} style={{color: '#000'}} target={'_blank'}
                        rel={'noopener noreferrer'}>www.allaboutcookies.org</Link>
                        adreslerini ziyaret edebilirsiniz.
                    </p>
                    <h3 style={{marginTop: 0}}>
                        Çerezler Vasıtasıyla Kişisel Verilerin Elde Edilmesi
                    </h3>
                    <p>
                        Web sitemizi ilk ziyaret edişinizde size çerez tercihlerinize ilişkin bir ekran sunulur. Bu
                        ekranda kullanımına izin verdiğiniz çerezler uyarınca ilgili çerezler
                        tarayıcınıza/cihazınıza depolanır. Çerezlerin her biri genellikle aşağıdaki unsurları
                        içerir:
                    </p>
                    <ol style={{marginTop: 0}}>
                        <li style={{listStyle: 'disc', margin: 0}}>
                            Çerezin gönderildiği sunucu,
                        </li>
                        <li style={{listStyle: 'disc', margin: 0}}>
                            Çerezin önceden belirlenmiş olan kullanım ömrü,
                        </li>
                        <li style={{listStyle: 'disc', margin: 0}}>
                            Genellikle rastgele oluşturulmuş benzersiz bir tanımlayıcı değer/numara (çerezi gönderen
                            web sitesi sunucusu, sayfalar arasında gezindiğinizde sizi tanımak için bu değeri
                            kullanır).
                        </li>
                    </ol>
                    <p>
                        Çerezler vasıtasıyla veriler tamamen otomatik yöntemlerle toplanmaktadır.
                    </p>
                    <h3 style={{marginTop: 0}}>
                        Çerezler Çeşitleri
                    </h3>
                    <p>
                        Çerezler, sahipleri, kullanım ömürleri ve kullanım amaçları bakımından sınıflandırılabilir:
                    </p>
                    <ol style={{marginTop: 0}}>
                        <li style={{listStyle: 'disc', margin: 0}}>
                            Sahibine göre çerezler, ziyaret ettiğiniz web sitesi tarafından cihazınıza yerleştirilen
                            birinci taraf çerezleri ve üçüncü taraflarca sunulan üçüncü taraf çerezleri
                            kullanılmaktadır. Birinci çerezleri, Pembe Panjur tarafından sunulurken, üçüncü taraf
                            çerezleri hizmet alınan veya iş ortağı olan farklı firmalarca sunulmaktadır.
                        </li>
                        <li style={{listStyle: 'disc', margin: 0}}>
                            Kullanım ömrüne göre, oturum çerezleri ve kalıcı çerezler kullanılmaktadır. Oturum
                            çerezleri ziyaretçinin web sitesini terk etmesiyle birlikte silinirken, kalıcı çerezler
                            önceden belirlenen kullanım ömürleri boyunca ziyaretçilerin cihazlarında saklanmakta ve
                            bir sonraki ziyaretinde ziyaretçiyi ve ziyaretçinin tercihlerini hatırlamak amacıyla
                            kullanılır.
                        </li>
                        <li style={{listStyle: 'disc', margin: 0}}>
                            Kullanım amaçlarına göre, sitede kesinlikle gerekli olan çerezler, analitik çereler,
                            işlevsellik çerezleri ve hedefleme/reklam çerezleri kullanılmaktadır.
                        </li>
                    </ol>

                    <h3 style={{marginTop: 20}}>
                        Çerezler Vasıtasıyla Toplanan Verilerin Hangi Amaçlarla İşleneceği ve Hukuki Sebepler
                    </h3>

                    <p>
                        Çerezler aracılığıyla, kullandığınız tarayıcı ve işletim sistemi, IP adresi, kullanıcı ID,
                        ziyaretinizin tarihi ve saati, erişim durumu ve teknik bir sorun olup olmadığı, web
                        sitesindeki özelliklerin kullanımı, girdiğiniz arama ifadeleri, web sitemizi ne sıklıkta
                        ziyaret ettiğiniz, dil tercihleriniz, sayfalarda gerçekleştirdiğiniz işlemler dahil
                        kullanıcı işlem kayıtlarına ilişkin veriler toplanmakta ve işlenmektedir.
                    </p>
                    <p>
                        Çerezler, web sitemizi ziyaretinizin ve buradaki deneyiminizin stabil bir şekilde
                        gerçekleştirilmesinin ve bir sonraki kullanımınızda bilgilerinizin hatırlanmasının
                        sağlanması, sitenin işleyişinin ve içeriğinin geliştirilmesi, site kullanımlarının
                        istatistiksel olarak değerlendirilmesi, sitede yer alan içeriğin sizin ve cihazınız için en
                        etkili şekilde sunulması ile kullanıcılara tercih ve kullanım alışkanlıkları doğrultusunda
                        özelleştirilmiş hizmetler ve reklamlar sunulması amaçlarıyla kullanılmaktadır. Çerezler
                        kullanım amaçları ve fonksiyonlarına göre çeşitli kategorilere ayrılmaktadır. Aşağıda
                        kategorilerine göre web sitemizde kullanılan çerezler ile ilgili çerezleri sağlayanlar,
                        çerezler ile kişisel veri aktarılabilecek yabancı ülkeler ve her bir çerez özelinde kullanım
                        amaçlarına ve hukuki sebeplerine yer verilmiştir:
                    </p>

                    <ol style={{marginTop: 0}}>
                        <li>
                                <span style={{fontWeight: 'bold'}}>
                                    Zorunlu (Teknik) Çerezler
                                </span>
                        </li>
                        <p>
                            Web sitesinin kullanımı, güvenliği ve işlerliği için gerekli olan çerezlerdir. Zorunlu
                            çerezler devre dışı bırakıldığı takdirde sitenin bir kısmına veya tümüne erişim mümkün
                            olmayabilir.
                        </p>
                        <p>
                            Söz konusu çerezler talep etmiş olduğunuz bir bilgi toplumu hizmetinin (log-in olma,
                            alışveriş sepetinize ürün ekleme, form doldurma ve gizlilik tercihlerinin hatırlanması)
                            yerine getirilebilmesi için zorunlu olarak kullanılmaktadırlar.
                        </p>
                        <p>
                            Söz konusu çerezler talep etmiş olduğunuz bir bilgi toplumu hizmetinin (log-in olma,
                            alışveriş sepetinize ürün ekleme, form doldurma ve gizlilik tercihlerinin hatırlanması)
                            yerine getirilebilmesi için zorunlu olarak kullanılmaktadırlar. Bu çerezler vasıtasıyla
                            işlenen kişisel veriler, KVKK Md.5/2 (e) bendinde öngörülen “bir hakkın tesisi,
                            kullanılması veya korunması için veri işlemenin zorunlu olması” sebebiyle veya (f)
                            bendinde öngörülen “İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla,
                            veri sorumlusunun meşru menfaatleri için veri işlenmesinin zorunlu olması” kapsamında
                            işlenmektedir.
                        </p>
                        <li>
                                <span style={{fontWeight: 'bold'}}>
                                    Tercih/İşlevsellik Çerezleri
                                </span>
                        </li>
                        <p>
                            Tercih çerezleri kullanıcıların web sitesindeki tercihlerini (gizlilik tercihleri
                            dışında) hatırlamak amacıyla kullanılır. Örneğin dil, para birimi tercihi veya kullanıcı
                            girişi sırasında aynı tarayıcıdan giriş yapıldığında tekrar giriş bilgilerinin
                            sorulmaması amacıyla kullanılan “beni hatırla” tercihi gibi kullanım tercihlerini
                            kaydedip sonraki ziyaretlerde hatırlanmasını sağlar.
                        </p>
                        <p>
                            Tercih çerezleri vasıtasıyla işlenen kişisel veriler, tercihlerin hatırlanması ve
                            müşteri deneyiminin iyileştirilmesi amaçlarıyla, KVKK Md.5/1’de öngörülen açık rızanıza
                            istinaden işlenmektedir. Yurt dışı kaynaklı çerezler ise KVKK Md9/1’de öngörülen açık
                            rızanıza istinaden işlenmekte yurt dışındaki çerez sağlayıcılarla paylaşılmaktadır.
                        </p>
                        <li>
                                <span style={{fontWeight: 'bold'}}>
                                    Analitik/Performans Çerezleri
                                </span>
                        </li>
                        <p>
                            Analitik çerezler kullanıcıların web sitesini nasıl kullandıkları hakkında bilgi toplar.
                            Bu tür çerezler kullanıcı deneyimlerini iyileştirmek/geliştirmek amacıyla kullanılan
                            çerezlerdir. Bu çerezler, kullanıcılar tarafından görüntülenen sayfalar, tıklanma
                            sayıları, sayfaları kaydırma hareketleri ve bu sayfalara giriş ve çıkış zamanları gibi
                            bilgileri toplar. Ayrıca performans ve analitik amaçlı çerezler internet sitemizdeki
                            ziyaretçilerin sayılması ve trafiğin ölçülmesine olanak sağlamaktadır. Bu sayede
                            sitemizin performansını ölçmekte ve iyileştirebilmekteyiz. Bu çerezler internet
                            sitemizdeki hangi sayfaların en popüler olduğu, hangilerinin de en az popüler olduğunu
                            anlamamıza yardımcı olmaktadır.
                        </p>
                        <p>
                            Analitik ve performans çerezleri vasıtasıyla işlenen kişisel verilerden, internet
                            sitemizdeki ziyaretçilerin sayılması ve trafiğin ölçülmesine olanak sağlayan birinci
                            taraf çerezler, ziyaretçi kayıtlarının oluşturulması ve takibi amacıyla KVKK Md.5/2 (f)
                            bendinde öngörülen “İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla,
                            veri sorumlusunun meşru menfaatleri için veri işlenmesinin zorunlu olması” kapsamında
                            işlenmektedir.
                        </p>
                        <p>
                            Analitik ve performans çerezleri vasıtasıyla işlenen kişisel verilerden, genellikle
                            üçüncü taraf olan ve pazarlama faaliyetlerinin analizi için kullanılan çerezler ise;
                            pazarlama analiz çalışmalarının yürütülmesi amacıyla, KVKK Md.5/1’de öngörülen açık
                            rızanıza istinaden işlenmektedir. Yurt dışı kaynaklı çerezler ise KVKK Md9/1’de
                            öngörülen açık rızanıza istinaden işlenmekte yurt dışındaki çerez sağlayıcılarla
                            paylaşılmaktadır.
                        </p>
                        <li>
                                <span style={{fontWeight: 'bold'}}>
                                    Reklam ve Pazarlama Çerezleri
                                </span>
                        </li>
                        <p>
                            Kullanıcıların ilgi alanlarına göre reklam/kampanyaların sunulması ve pazarlama
                            çalışmalarının etkinliğini ölçmek amacıyla kullanılan çerezlerdir.
                        </p>
                        <p>
                            Pazarlama çerezleri vasıtasıyla işlenen kişisel veriler, ürün / hizmetlerin pazarlama
                            süreçlerinin yürütülmesi pazarlama analiz çalışmalarının yürütülmesi ve reklam /
                            kampanya / promosyon süreçlerinin yürütülmesi amaçlarıyla, KVKK Md.5/1’de öngörülen
                            açık rızanıza istinaden işlenmektedir. Yurt dışı kaynaklı çerezler ise KVKK Md9/1’de
                            öngörülen açık rızanıza istinaden işlenmekte yurt dışındaki çerez sağlayıcılarla
                            paylaşılmaktadır.
                        </p>
                        <CookieTable/>
                        <li>
                                <span style={{fontWeight: 'bold'}}>
                                    Üçüncü Taraf Çerez Sağlayıcıların Bilgileri
                                </span>
                        </li>
                        <ol style={{marginTop: 0, paddingLeft: 0}}>
                            <li style={{listStyle: 'disc', margin: 0}}>
                                Google Inc. tarafından sağlanan çerezler kullanılmaktadır. Google Inc’in sunduğu
                                hizmetler (Youtube dahil) kapsamında kişisel verilerinizin işlenmesi hakkında
                                kapsamlı bilgi için:
                                <a href={'https://static.googleusercontent.com/media/www.google.com/tr//intl/tr/policies/privacy/google_privacy_policy_tr.pdf'}
                                   target={'_blank'} rel={'noopener noreferrer'} style={{
                                    fontWeight: 'bold',
                                    color: '#000',
                                    maxWidth: '100%',
                                    wordWrap: 'break-word'
                                }}> www.google.com/intl/tr/policies/privacy/infocollect</a>
                            </li>
                            <li style={{listStyle: 'disc', margin: 0}}>
                                Spotify’ın kişisel verilerinizi nasıl işlediği hakkında kapsamlı bilgi için: <a
                                href={'https://www.spotify.com/tr-tr/legal/cookies-policy/'} target={'_blank'}
                                rel={'noopener noreferrer'}
                                style={{
                                    fontWeight: 'bold',
                                    color: '#000',
                                    maxWidth: '100%',
                                    wordWrap: 'break-word'
                                }}>https://www.spotify.com/tr/legal/cookies-policy/</a>
                            </li>
                        </ol>
                        <p>
                            Üçüncü taraf çerezler için hizmet alınan firmaların bir kısmı yurtdışında yerleşik olup,
                            söz konusu çerezlerin kullanımı durumunda bazı kişisel verileriniz yurtdışına
                            aktarılabilir. Bu nedenle web sitesindeki çerez tercihleri kısmında, ilgili çerezlerin
                            kullanımı ve bu kapsamda verilerinizin yurtdışına aktarımı için rızanız sorulmaktadır.
                            Eğer söz konusu çerezlerin kullanılmasını ve bu doğrultuda kişisel verilerinizin yurt
                            dışına aktarılmasını istemiyorsanız, lütfen belirtilen çerezlerle kişisel veri
                            işlenmesine rıza vermeyiniz. Bu kapsamda vermiş olduğunuz rızaları her zaman <Link
                            href={'/cerez-politikasi'} style={{textDecoration: 'underline', color: '#000'}}>Çerez
                            Tercihleri</Link> ekranından geri alabileceğinizi belirtmek isteriz.
                        </p>
                        <p>
                            Ayrıca tarayıcınızın ayarlarını değiştirerek çerezleri etkinleştirebilir veya devre dışı
                            bırakabilirsiniz. Ancak bu durumda web sitesinin bir kısım veya tüm fonksiyonlarından
                            yararlanılması mümkün olmayabilir. Sitenin işlerliği için zorunlu olan bazı çerezlerin
                            (teknik çerezler gibi) engellenmesi ise mümkün değildir. Çerezleri nasıl devre dışı
                            bırakacağınız hakkında, aşağıda tarayıcınıza özgü linke tıklayarak bilgi alabilirsiniz:
                        </p>
                        <ol style={{marginTop: 0}}>
                            <li style={{listStyle: 'disc', margin: 0}}>Google Chrome</li>
                            <li style={{listStyle: 'disc', margin: 0}}>Microsoft Edge</li>
                            <li style={{listStyle: 'disc', margin: 0}}>Mozilla Firefox</li>
                            <li style={{listStyle: 'disc', margin: 0}}>Safari</li>
                            <li style={{listStyle: 'disc', margin: 0}}>Opera</li>
                        </ol>
                        <p>
                            Çerez tercihlerinizi değiştirmek için <a href={'/cerez_politikasi'} style={{
                            textDecoration: 'underline',
                            color: '#000'
                        }}>Çerez Tercihleri</a> ekranını da kullanabilirsiniz.
                        </p>
                        <li>
                                <span style={{fontWeight: 'bold'}}>
                                    Çerezler Vasıtasıyla İşlenen Kişisel Verilerle İlgili Veri Sorumlusuna Başvuru
                                </span>
                        </li>
                        <p>
                            Web sitemiz üzerinden çerezler vasıtası ile işlenen kişisel verilerinize ilişkin 6698
                            sayılı Kanun’un “ilgili kişinin haklarını düzenleyen” 11’inci maddesi kapsamındaki
                            taleplerinizi;
                        </p>
                        <ol style={{marginTop: 0}}>
                            <li style={{listStyle: 'disc', margin: 0}}>
                                Yeşilköy Mah. Atatürk Cad. No: 12/2 EGS Business Park B3 Blok Ofis 264 adresine
                                yazılı olarak;
                            </li>
                            <li style={{listStyle: 'disc', margin: 0}}>
                                <a
                                    href="mailto:panjur.bilisim@hs02.kep.tr"
                                    rel={'noopener noreferrer'}
                                    style={{color: '#000'}}>panjur.bilisim@hs02.kep.tr</a> kayıtlı elektronik posta
                                adresine kayıtlı elektronik
                                posta adresinizi kullanarak;
                            </li>
                            <li style={{listStyle: 'disc', margin: 0}}>
                                Sistemimizde kayıtlı bulunan elektronik posta adresinizi kullanarak
                                <a href="mailto:kvk@pembepanjur.com"
                                   rel={'noopener noreferrer'}
                                   style={{color: '#000'}}> kvk@pembepanjur.com
                                </a> adresine e-posta göndererek iletebilirsiniz.
                            </li>
                        </ol>
                        <p>
                            Başvuru yapılırken uyulması gereken usul ve esaslar hakkındaki daha detaylı bilgiye
                            Kişisel Verileri Koruma Kurumu'nun Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında
                            Tebliğ'den ulaşabilirsiniz.
                        </p>
                    </ol>
                </TextArea>
            </WaveLayout>
        </React.Fragment>
    )
}

import { checkAuthAndRedirect } from '../src/utils/authHelper';
export const getServerSideProps = async (context: any) => {
    return await checkAuthAndRedirect(context);
};

export default CerezPolitikasi;
